import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Home, Users, Building2, FileSignature, Wallet, Sparkles, LogOut,
} from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const NAV = [
  { to: "/", label: "Accueil", icon: Home, end: true, testid: "ms-nav-home" },
  { to: "/prospects", label: "Prospects", icon: Sparkles, testid: "ms-nav-prospects" },
  { to: "/clients", label: "Clients", icon: Users, testid: "ms-nav-clients" },
  { to: "/biens", label: "Biens", icon: Building2, testid: "ms-nav-biens" },
  { to: "/encaissement", label: "Cash", icon: Wallet, testid: "ms-nav-encaisse" },
];

/**
 * Layout mobile staff — optimisé pour mobile, tablet et desktop (jusqu'à 1024px effectif,
 * au-delà le contenu reste centré avec marge confortable, parfait sur tablette).
 */
export default function MobileStaffLayout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const initials = (user?.name || user?.email || "?").slice(0, 2).toUpperCase();

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col" style={{ fontFamily: "Inter, system-ui, sans-serif" }}>
      {/* TOP BAR */}
      <header className="sticky top-0 z-30 bg-white border-b border-[#E2E5F1]">
        <div className="max-w-5xl mx-auto px-5 h-14 flex items-center justify-between">
          <button onClick={() => navigate("/")} className="flex items-center gap-2" data-testid="ms-header-logo">
            <img src="/logo-tpco.png" alt="TPCO" className="h-7 w-auto" />
            <span className="text-[10px] uppercase tracking-wider font-bold text-[#E91E63] hidden sm:inline">Staff</span>
          </button>
          {title && (
            <h1 className="font-display text-base sm:text-lg font-bold text-[#0F1A3D] truncate max-w-[55%]" style={{ fontFamily: "'Playfair Display', serif" }}>
              {title}
            </h1>
          )}
          <button
            onClick={() => navigate("/profil")}
            className="w-8 h-8 rounded-full bg-gradient-to-br from-[#1E3A8A] to-[#E91E63] text-white text-xs font-bold flex items-center justify-center"
            data-testid="ms-header-avatar"
          >
            {initials}
          </button>
        </div>
      </header>

      {/* CONTENT */}
      <main className="flex-1 pb-24 max-w-5xl mx-auto w-full">{children}</main>

      {/* BOTTOM NAV */}
      <nav className="fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-[#E2E5F1]" data-testid="ms-bottom-nav">
        <div className="max-w-5xl mx-auto grid grid-cols-5 h-16">
          {NAV.map(({ to, label, icon: Icon, end, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 text-[10px] font-bold uppercase tracking-wider relative ${
                  isActive ? "text-[#1E3A8A]" : "text-[#9CA3B5]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className={`w-5 h-5 ${isActive ? "stroke-[2.4]" : "stroke-[1.8]"}`} />
                  <span>{label}</span>
                  {isActive && <span className="absolute bottom-1 w-1 h-1 rounded-full bg-[#E91E63]" />}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
